import { render, staticRenderFns } from "./itsMine.vue?vue&type=template&id=1d97f85e&scoped=true&"
import script from "./itsMine.vue?vue&type=script&lang=js&"
export * from "./itsMine.vue?vue&type=script&lang=js&"
import style0 from "./itsMine.vue?vue&type=style&index=0&id=1d97f85e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d97f85e",
  null
  
)

export default component.exports